// @flow

import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";

import { localize } from "redux-i18n";
import Ajv from "ajv";

import actionCreators from "@modules/service/actionCreator";
import * as serviceSelectors from "@modules/service/selectors";
import { SchemaForm, Button, type StepProps } from "@components";
import type { ManagerSmsRestriction } from "@modules/service/reducer/manager-sms-notifications/types";
import type { State } from "@store/reducers";

import schema from "./schema";
import uiSchema from "./ui-schema";

type PropsFromState = $Exact<{
  current: ?ManagerSmsRestriction,
}>;

type PropsFromDispatch = $Exact<{
  setCurrent: typeof actionCreators.SetManagerSmsNotificationCurrent,
}>;

type Props = $Exact<{
  ...StepProps,
  ...PropsFromState,
  ...PropsFromDispatch,
  ...PropsFromLocalize,
}>;

export class Step1Rule extends React.Component<Props> {
  static defaultProps = {
    onChange: () => {},
  };

  constructor(props: Props) {
    super(props);

    this.formRef = React.createRef();
  }
  isValid = (data: Object) => {
    return new Ajv().validate(schema, data);
  };

  handleNext = () => {
    this.formRef.current.submit();
  };

  handleFormChange = (formData: Object) => {
    this.props.setCurrent(formData);
    this.props.onChange(formData, this.isValid(formData));
  };

  handleFormSubmit = (formData: Object) => {
    this.props.setCurrent(formData);
    this.props.handleSubmit(formData, this.isValid(formData));
  };

  render() {
    if (!this.props.editable) {
      return null;
    }

    return (
      <React.Fragment>
        <div className="w-100 d-flex justify-content-center gs-container">
          {this.props.current ? (
            <SchemaForm
              ref={this.formRef}
              className="w-100"
              formData={this.props.current}
              schema={schema}
              uiSchema={uiSchema}
              onChange={this.handleFormChange}
              onSubmit={this.handleFormSubmit}
              externalSubmit
            >
              <div className="d-flex justify-content-center" />
            </SchemaForm>
          ) : null}
        </div>
        <div className="w-100 d-flex justify-content-end mt-5 mb-3">
          <Button
            materialIcon="fast_forward"
            disabled={!this.isValid(this.props.current || {})}
            onClick={this.handleNext}
          >
            {this.props.t("NEXT")}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: State, ownProps: Object): PropsFromState => {
  return {
    current: serviceSelectors.getManagerSmsCurrent(state),
  };
};

const mapDispatchToProps: PropsFromDispatch = {
  setCurrent: actionCreators.SetManagerSmsNotificationCurrent,
};

export default compose(localize(), connect(mapStateToProps, mapDispatchToProps))(Step1Rule);
